import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD3x3Pq-BsstrPhZGDM2ejlrgHZmCU1kFY",
  authDomain: "advanced-bowling-tracker.firebaseapp.com",
  projectId: "advanced-bowling-tracker",
  storageBucket: "advanced-bowling-tracker.firebasestorage.app",
  messagingSenderId: "182960062923",
  appId: "1:182960062923:web:7bedc606ad270fcb09f64e",
  measurementId: "G-93JVCB821X"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
